import { useAuth0 } from "@auth0/auth0-react";
import FinanceService from "Lib/API/Finance";
import FinanceSettingService from "Lib/API/FinanceSetting/FinanceSetting";
import { InputField, LabelField, MyCheckbox } from "components";
import AlertDialog from "components/Dialog";
import InfoTooltip from "components/InfoTooltip";
import Button from "components/button/Button";
import { useSearch } from "hook";
import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { useHistory, useLocation } from "react-router-dom";
import Select, { components } from "react-select";
import BottomArrowSvg from "../../../../../src/assets/icons/svg/BottomArrowSvg";

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <BottomArrowSvg label="Emoji" />
    </components.DropdownIndicator>
  );
};

const AddNewBankAccount = ({
  addNew,
  formik,
  edit,
  type,
  updateFunc,
  createFunc,
  setDaisableAddNew,
  setEdit,
  setAddNew,
  setDisable,
  disable,
  disableAddNew,
}) => {
  const localStorageData = localStorage.getItem("organization")
    ? JSON.parse(localStorage.getItem("organization"))
    : null;

  const [search, setSearch] = useState("");
  const [loading, setLoading] = React.useState(false);

  const { getAccessTokenSilently } = useAuth0();
  const { searchAction } = useSearch({ action: setSearch });

  const [openDisableAlert, setOpenDisableAlert] = useState(false);
  const { push } = useHistory();
  const validateCreateFunc = () => {
    if (formik.values?.bank_account_name === "") {
      return toastr.info("Validation", "Please fill the name field");
    }
    createFunc();
    // push({
    //   pathname: "/bank-accounts/view",
    // });
  };
  const handleCloseDialog = () => {
    setOpenDisableAlert(false);
  };
  const handleOnClose = (e) => {
    setOpenDisableAlert(false);
    e.preventDefault();
    setAddNew(true);
    setEdit(true);
    setDisable(true);
    setDaisableAddNew(true);
    formik.setFieldValue("bank_account_name", "");
    formik.setFieldValue("default_bank_account", false);
    push({
      pathname: "/financial-setting/bank-accounts/view",
    });
  };

  useEffect(() => {
    if (disable === false) {
      setEdit(true);
      setDaisableAddNew(true);
      setDisable(true);
      setAddNew(true);
      push({
        pathname: "/financial-setting/bank-accounts/view",
      });
    }
  }, []);

  const [bol, setBol] = useState(1);
  const [queryResponse, setQueryResponse] = useState([]);
  const [selectedQuery, setSelectedQuery] = useState({
    Id: formik?.values?.quickBooks_id ?? "",
    Name: formik?.values?.quickBooks_name ?? "",
  });

  useEffect(() => {
    if (addNew) {
      setSelectedQuery({
        Id: "",
        Name: "",
      });
    }
  }, [addNew]);

  useEffect(() => {
    if (
      localStorageData?.quickBooks_information?.program === "online" &&
      bol === 1
    ) {
      getQuickBooksURL();
      setBol(2);
    }
  }, [localStorageData]);

  const getQuickBooksURL = async (row) => {
    const token = await getAccessTokenSilently();
    await FinanceService.GetDepositQuickbooks(token).then((res) => {
      if (res?.result?.authenticated === true) {
        // createNewDeposit(row);
        getAccountListForQB();
      } else {
        window.open(
          res?.result?.url,
          "_blank",
          "toolbar=0,location=0,menubar=0"
        );
      }
    });
  };

  const handleQueryArray = (value) => {
    setSelectedQuery({
      Id: value.value,
      Name: value.label,
    });
    formik.setFieldValue(`quickBooks_name`, value.label);
    formik.setFieldValue(`quickBooks_id`, value.value);
  };

  const getAccountListForQB = async () => {
    const token = await getAccessTokenSilently();
    await FinanceSettingService.GetListOfAccountForQB("Bank", token)
      .then((res) => {
        const data = res?.result?.QueryResponse?.Account?.map(
          (item, index) => ({
            value: item?.Id,
            label: item?.Name,
          })
        );
        setQueryResponse(data);
        // setReceivableAccounts(res?.result);
      })
      .catch((e) => {
        toastr.error(e?.data?.message ?? "Error");
      });
  };

  const formatOptionLabel = ({ label, _id }) => {
    return (
      <div className="dropdown-container" key={_id}>
        <div className="icon-name-container d-flex align-items-center justify-content-start">
          <div className="name-container" style={{ marginInlineStart: 10 }}>
            <div>{label}</div>
          </div>
        </div>
      </div>
    );
  };
  const selectControlStyles = {
    backgroundColor: "#F3F6F9",
    borderColor: "#F3F6F9",
    color: "#3F4254",
    transition:
      "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
    paddingTop: "6px",
    paddingBottom: "6px",
    cursor: "pointer",
  };

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      ...selectControlStyles,
    }),
  };


  const isProgramSage = localStorageData?.quickBooks_information?.program === "sage";
  const isProgramOnline = localStorageData?.quickBooks_information?.program === "online";
  const isProgramDisable = localStorageData?.quickBooks_information?.program === "disable";


  return (
    <div>
      <div className="input-fields">
      <div className="d-flex justify-content-end pb-5 pr-10">
          <Button
            onClick={() => setOpenDisableAlert(true)}
            variant="primary-outline"
            size="md"
            style={{ minWidth: 80 }}
          >
            Cancel
          </Button>
          <Button
            className="ml-5"
            onClick={
              edit === true
                ? updateFunc
                : addNew === true
                ? validateCreateFunc
                : ""
            }
            variant="primary"
            size="md"
            style={{ minWidth: 80 }}
          >
            Save
          </Button>
          <AlertDialog
            open={openDisableAlert}
            handleClose={handleCloseDialog}
            onDecline={() => {
              setOpenDisableAlert(false);
            }}
            onAccept={handleOnClose}
            title={"Are you sure?"}
            description={"Do you want to discard the changes you made?"}
          />
        </div>
        <div
          style={{
            display: "flex",
          }}
        >
          <div className="col-sm-5 bank-account-fields">
            <div className="position-relative bank-account-input-field ">
              <InputField
                type="text"
                {...{
                  formik,
                  title: "Bank Account Name",
                  name: `bank_account_name`,
                  placeholder: "Bank Account Name",
                  mandatory: true
                }}
                value={formik.values?.bank_account_name}
                style={{
                  backgroundColor: "#F3F6F9",
                }}
              />{" "}
            </div>
          </div>
          <div className="col-sm-5 bank-account-fields">
            {!isProgramDisable && (
              <div className="position-relative bank-account-input-field ">
                {queryResponse?.length > 0 ? (
                  <>
                    <LabelField mandatory={true} title={isProgramSage ? "Sage Name" : "QuickBooks Name"} hint="Ties this bank account to the corresponding account in your connected accounting software." />

                    <Select
                      {...{
                        formik,
                        name: `account_receivable`,
                        checkValidation: false,
                        placeholder: isProgramSage ? "Sage Name" : "QuickBooks Name",
                      }}
                      onInputChange={(text) => searchAction(text)}
                      classNamePrefix="react-select"
                      formatOptionLabel={formatOptionLabel}
                      options={queryResponse}
                      isLoading={loading}
                      styles={colourStyles}
                      onChange={(value) => handleQueryArray(value)}
                      value={
                        selectedQuery
                          ? {
                              label: selectedQuery?.Name,
                              value: selectedQuery?.Id,
                            }
                          : ""
                      }
                      components={{ DropdownIndicator }}
                      isDisabled={false}
                    />
                  </>
                ) : (
                  <>
                    <LabelField mandatory title={isProgramSage ? "Sage Name" : "QuickBooks Name"} hint="Ties this bank account to the corresponding account in your connected accounting software." />
                    <InputField
                      {...{
                        formik,
                        title: "none",
                        name: "quickBooks_name",
                        placeholder: isProgramSage ? "Sage Name" : "QuickBooks Name",
                        mandatory: true
                      }}
                      formStyle={{ marginBottom: 0 }}
                      value={formik.values?.quickBooks_name}
                      style={{
                        height: "48px",
                        backgroundColor: "#F3F6F9",
                      }}
                    />
                  </>
                )}
              </div>
            )}
          </div>
        </div>

        <div
          style={{
            display: "flex",
          }}
        >
          {(isProgramOnline || isProgramSage) && (
            <div className="col-sm-5 bank-account-fields">
              <div className="position-relative bank-account-input-field ">
                <InputField
                  {...{
                    formik,
                    title: isProgramSage ? "Sage ID" : "QuickBooks ID",
                    name: "quickBooks_id",
                    placeholder: isProgramSage ? "Sage ID" : "QuickBooks ID",
                    mandatory: true
                  }}
                  value={formik.values?.quickBooks_id}
                  disabled={queryResponse?.length > 0 && true}
                  style={{
                    height: "48px",
                    backgroundColor: "#F3F6F9",
                  }}
                />
              </div>
            </div>
          )}
          <div className="mt-13 bank-checkbox add-checkbox" style={{ display: 'flex', alignItems: 'center' }}>
            <MyCheckbox
              name={`default_bank_account`}
              title="Default Bank Account"
              handlechange={(event) => {
                formik.setFieldValue(
                  "default_bank_account",
                  event.target.checked
                );
              }}
              checked={formik.values?.default_bank_account}
              value={formik.values?.default_bank_account}
            />
            <InfoTooltip text="Marks this as the default deposit destination used across the app when no specific bank account is chosen." style={{ marginLeft: '6px', marginBottom: '8px' }} />
          </div>
        </div>
        
      </div>
    </div>
  );
};

export default AddNewBankAccount;
